import RelativeSumKeyItem from "../../../items/games/relativeSumGameScreen/RelativeSumKeyItem";
import RelativeSumGameValidateButton from "../../../buttons/games/RelativeSumGameValidateButton";

export default function RelativeDifferenceGameKeyboard({userSign, userAnswer, onKeyPressed}) {
    // Used in RelativeSumGameContent to display
    // specific keyboard fo this game

    // CONSTANTS
    const keys = [
        '1', '2', '3',
        '4', '5', '6',
        '7', '8', '9',
        '-/+', '0', 'Erase'
    ];

    // BUILD
    return (
        <div className={"w-full flex flex-col mt-[24px]"}>
            <div className="w-full grid grid-cols-3 gap-[12px]">
                {keys.map((item, index) => (
                    <RelativeSumKeyItem key={index}
                                        item={item}
                                        userSign={userSign}
                                        userAnswer={userAnswer}
                                        onKeyPressed={onKeyPressed} />
                ))}
            </div>
            <RelativeSumGameValidateButton userAnswer={userAnswer}
                                           userSign={userSign}
                                           onKeyPressed={onKeyPressed} />
        </div>
    );
}